import { makeVar } from '@apollo/client'

const defaultOwnerId: string = ''

export const ownerId = makeVar<string>(defaultOwnerId)

export const updateOwnerId = (value: string) => {
    ownerId(value)
}
